import { render, staticRenderFns } from "./Metamaskbtn.vue?vue&type=template&id=24fd8e14&scoped=true&"
import script from "./Metamaskbtn.vue?vue&type=script&lang=js&"
export * from "./Metamaskbtn.vue?vue&type=script&lang=js&"
import style0 from "./Metamaskbtn.vue?vue&type=style&index=0&id=24fd8e14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fd8e14",
  null
  
)

export default component.exports